import { render, staticRenderFns } from "./Assurance.vue?vue&type=template&id=6825a410&scoped=true&"
import script from "./Assurance.vue?vue&type=script&lang=js&"
export * from "./Assurance.vue?vue&type=script&lang=js&"
import style0 from "./Assurance.vue?vue&type=style&index=0&id=6825a410&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6825a410",
  null
  
)

export default component.exports